import React from "react";
import { AlertTriangle, Briefcase, Users } from "lucide-react";
import { COLORS } from "../../utils/constants";
import { formatCurrency } from "../../utils/formatters";

const Scenario = ({ icon: Icon, title, children, testid }) => (
  <div className="rounded-lg bg-white border p-3" data-testid={testid}>
    <div className="flex items-center gap-1.5 text-sm font-semibold mb-1" style={{ color: COLORS.text }}><Icon size={15} /> {title}</div>
    <div className="text-sm">{children}</div>
  </div>
);

export const TvaImpact = ({ t }) => {
  if (!t?.concerne) return null;
  if (t.deja_assujetti) {
    return (
      <div className="rounded-xl border p-4 text-sm" style={{ backgroundColor: COLORS.bg }} data-testid="simulateur-tva-impact">
        Tu factures déjà la TVA : ce contrat se facture avec {t.taux}% de TVA en plus ({formatCurrency(t.tva_a_facturer_en_plus)}), que tu reverses ensuite.
      </div>
    );
  }
  return (
    <section className="rounded-xl border-2 p-5 flex flex-col gap-3" style={{ borderColor: COLORS.error + "66", backgroundColor: COLORS.error + "08" }} data-testid="simulateur-tva-impact">
      <div className="flex items-start gap-2">
        <AlertTriangle size={20} style={{ color: COLORS.error }} className="flex-shrink-0 mt-0.5" />
        <div>
          <h2 className="text-base md:text-lg font-semibold" style={{ color: COLORS.error }}>Ce contrat te fait sortir de la franchise de TVA</h2>
          <p className="text-sm" data-testid="simulateur-tva-raison">{t.raison} {t.nb_mois_concernes} mois du contrat {t.nb_mois_concernes > 1 ? "sont concernés" : "est concerné"}.</p>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        <Scenario icon={Briefcase} title="Si tu ajoutes la TVA à ton prix" testid="simulateur-tva-scenario-ajoutee">
          Ton client paie <strong>{formatCurrency(t.tva_a_facturer_en_plus)}</strong> de TVA en plus, que tu reverses. Ton net ne change pas.
          <span className="block text-xs text-muted-foreground mt-1">Cas habituel avec un client professionnel, qui récupère la TVA.</span>
        </Scenario>
        <Scenario icon={Users} title="Si ton prix TTC reste le même" testid="simulateur-tva-scenario-ttc">
          La TVA est prise sur ton prix : ton net baisse d'environ <strong style={{ color: COLORS.error }}>{formatCurrency(t.perte_net_si_prix_ttc)}</strong>.
          <span className="block text-xs text-muted-foreground mt-1">Cas habituel avec un particulier, qui ne récupère pas la TVA.</span>
        </Scenario>
      </div>
      <ul className="text-xs text-muted-foreground list-disc pl-5 space-y-0.5">
        <li>Tes factures devront mentionner la TVA ({t.taux}% au taux normal) dès {t.debut}.</li>
        <li>Tu devras déclarer et reverser la TVA aux impôts, sur toutes tes ventes de la période, pas seulement ce contrat.</li>
        <li>En contrepartie, tu pourras récupérer la TVA payée sur tes achats professionnels.</li>
      </ul>
    </section>
  );
};

export default TvaImpact;
